import { inputCommon } from '../inputCommon'
import type { FieldInputProps } from '../types'

export function DateInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <input
      type="date"
      id={`field-${field.fieldCode}`}
      className={inputCommon(disabled)}
      disabled={disabled}
      value={typeof value === 'string' ? value : ''}
      onChange={e => onChange(e.target.value || null)}
    />
  )
}
